import { css } from "@microsoft/fast-element";
import { display, spacingHorizontalM, spacingHorizontalS, spacingVerticalS } from "@fluentui/web-components";
export const styles = css `
  ${display("flex")}
  :host {
    display: grid;
    grid-template-columns: 1fr min-content;
  }
  .content {
    display: flex;
    column-gap: var(--card-size, ${spacingHorizontalM});
    padding: ${spacingVerticalS} ${spacingHorizontalS};
  }
`;
//# sourceMappingURL=card-footer.styles.js.map